// SGK Hizmet Listesi personel teyidi: ✓ listede / yeni giriş, ✗ listede yok, ! uyarıya rağmen onaylandı

// Talep işaretleri + firma düzeyindeki SGK listesi hafızası birleşimi
export const buildSgkData = (formData, company) => {
  const c = company?.documents || {};
  const permitList = formData.sgk_listed_employee_ids;
  const reviewed = c.sgk_hizmet_listesi_reviewed_ids || [];
  if (!Array.isArray(permitList) && !reviewed.length) return { ...formData, sgk_listed_employee_ids: null };
  const listed = [...new Set([...(permitList || []), ...(c.sgk_hizmet_listesi_listed_ids || [])])];
  return { ...formData, sgk_listed_employee_ids: listed, sgk_reviewed_ids: [...new Set([...reviewed, ...listed])], sgk_list_date: formData.sgk_list_date || c.sgk_hizmet_listesi_validity || '' };
};
import { CheckCircle2, XCircle, AlertCircle } from 'lucide-react';
import { Checkbox } from '../../ui/checkbox';

export const SGK_WARNING = "SGK hizmet listesinde adı yoktur. Bu nedenle SGK'si olmayabilir.";

const monthBefore = (iso) => {
  const [y, m, d] = iso.slice(0, 10).split('-').map(Number);
  const dim = new Date(Date.UTC(y, m - 1, 0)).getUTCDate();
  const t = new Date(Date.UTC(y, m - 2, Math.min(d, dim)));
  return t.toISOString().slice(0, 10);
};

// İşe giriş tarihi, hizmet listesi tarihinden 1 ay veya daha eskiyse listede görünmesi gerekirdi
export const sgkNeedsWarning = (formData, empId, iseDate) => {
  const listed = formData.sgk_listed_employee_ids;
  if (!Array.isArray(listed) || listed.includes(empId) || !formData.sgk_list_date || !iseDate) return false;
  return iseDate.slice(0, 10) <= monthBefore(formData.sgk_list_date);
};

export const sgkMark = (formData, emp) => {
  const listed = formData.sgk_listed_employee_ids;
  if (!Array.isArray(listed)) return null;
  if (listed.includes(emp.id)) return 'ok';
  if (Array.isArray(formData.sgk_reviewed_ids) && !formData.sgk_reviewed_ids.includes(emp.id)) return null;
  const docs = emp.documents || {};
  if (docs.sgk_ise_giris !== 'onay' || !docs.sgk_ise_giris_date) return 'x';
  if (!sgkNeedsWarning(formData, emp.id, docs.sgk_ise_giris_date)) return 'ok';
  return (formData.sgk_warning_ack_ids || []).includes(emp.id) ? 'warn' : 'x';
};

const MARKS = {
  ok: { Icon: CheckCircle2, cls: 'text-emerald-600', title: 'SGK teyit edildi' },
  x: { Icon: XCircle, cls: 'text-rose-600', title: "SGK Hizmet Listesi'nde teyit edilmedi" },
  warn: { Icon: AlertCircle, cls: 'text-amber-500', title: `${SGK_WARNING} Uyarıya rağmen onaylandı.` },
};

export const SgkMarkIcon = ({ mark, empId }) => {
  if (!mark) return <span className="text-xs text-slate-400" title="SGK Hizmet Listesi henüz onaylanmadı" data-testid={`sgk-mark-${empId}`}>—</span>;
  const { Icon, cls, title } = MARKS[mark];
  return <span title={title} data-testid={`sgk-mark-${empId}`} data-mark={mark}><Icon className={`h-5 w-5 ${cls}`} /></span>;
};

export const SgkEmployeeChecklist = ({ employees, checked, onChange }) => (
  <div className="space-y-1" data-testid="sgk-employee-checklist">
    <label className="text-xs text-slate-500">Hizmet listesinde adı olan personelleri işaretleyin</label>
    <div className="max-h-44 space-y-1 overflow-y-auto rounded border bg-white p-2">
      {employees.length === 0 && <p className="text-xs text-slate-400">Talepte personel yok</p>}
      {employees.map(e => (
        <label key={e.id} className="flex cursor-pointer items-center gap-2 text-xs">
          <Checkbox checked={checked.includes(e.id)} onCheckedChange={(v) => onChange(v ? [...checked, e.id] : checked.filter(x => x !== e.id))} data-testid={`sgk-check-${e.id}`} />
          <span className="text-slate-700">{e.name} {e.surname}</span>
        </label>
      ))}
    </div>
    <p className="text-[11px] text-slate-500">{checked.length}/{employees.length} personel işaretli</p>
  </div>
);
